var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChestpocket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5998 9.72925H58.3679H9.95239H8.45239V11.2292V22.4021V53.2603V54.0501L9.10363 54.497L14.1303 57.9468L16.2947 55.7936L11.4524 52.4704V24.5804L37.6255 34.5738L40.9988 31.218L39.1936 31.9613L11.4524 21.3692V12.7292H58.3679H59.5841L62.5998 9.72925ZM59.019 23.7979L64.8485 21.3975V17.9987L67.8485 15.0143V22.4021V54.3244V55.1736L67.1202 55.6106L66.3485 54.3244C67.1202 55.6106 67.1201 55.6106 67.12 55.6107L67.1193 55.6111L67.1166 55.6127L67.106 55.6191L67.0639 55.6443L66.8987 55.7435L66.2629 56.125L63.9197 57.5309L56.1469 62.1946L37.8581 73.1679L37.0319 73.6635L36.2376 73.1184L20.3802 62.2359L22.5446 60.0827L37.1407 70.0997L54.6034 59.6221L62.3762 54.9584L64.7194 53.5525L64.8485 53.4751V24.6419L53.4544 29.3335L59.019 23.7979Z",
    fill: "#333333"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70.7791,
    y: 5.43652,
    width: 3.19223,
    height: 89.3824,
    transform: "rotate(45.915 70.7791 5.43652)",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChestpocket);
export default __webpack_public_path__ + "static/media/chestpocket.79ff734067795262b83b3bd02464a24b.svg";
export { ForwardRef as ReactComponent };